import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatProgressBarModule, MatTooltipModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { AddressComponent } from './address.component';

@NgModule({
  declarations: [
    AddressComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,

    MatFormFieldModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatIconModule,
    MatTooltipModule,
    MatInputModule,
    MatButtonModule
  ],
  exports: [
    AddressComponent
  ]
})
export class AddressModule { }
